var map = {
	"./Sem Título": 10,
	"./Sem Título.png": 10,
	"./cash-white": 11,
	"./cash-white.png": 11,
	"./checkbox-filled-in": 12,
	"./checkbox-filled-in.png": 12,
	"./custom-select": 13,
	"./custom-select.png": 13,
	"./favicon": 6,
	"./favicon.ico": 185,
	"./favicon.png": 6,
	"./glg-premium": 14,
	"./glg-premium.png": 14,
	"./golf-background": 7,
	"./golf-background.jpg": 186,
	"./golf-background.png": 7,
	"./icon/danger": 15,
	"./icon/danger.svg": 15,
	"./icon/four_player_scramble": 16,
	"./icon/four_player_scramble.png": 16,
	"./icon/individual_stableford": 17,
	"./icon/individual_stableford.png": 17,
	"./icon/success": 18,
	"./icon/success.svg": 18,
	"./icon/two_player_bestball": 19,
	"./icon/two_player_bestball.png": 19,
	"./icon/warning": 20,
	"./icon/warning.svg": 20,
	"./logo-black": 21,
	"./logo-black.png": 21,
	"./logo-branding": 22,
	"./logo-branding.png": 22,
	"./logo-icon": 23,
	"./logo-icon.png": 23,
	"./logo-outings-blue": 24,
	"./logo-outings-blue.png": 24,
	"./logo-outings-text": 25,
	"./logo-outings-text.png": 25,
	"./logo-text": 26,
	"./logo-text.png": 26,
	"./logo-white": 27,
	"./logo-white.png": 27,
	"./xleague-branding": 28,
	"./xleague-branding.png": 28,
	"./xleague_logo": 29,
	"./xleague_logo.png": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;